export const getCurrentMonthSumUlosotto = state => state.admin.currentMonthSumUlosotto
export const getMaxMonthlyGovPay = state => state.admin.maxMonthlyGovPay
export const getIsAdminSent = state => state.admin.isAdminSent
export const getIsAdminHalfPaid = state => state.admin.isAdminHalfPaid
export const getIsAdminRejected = state => state.admin.isAdminRejected
export const showSalaryItemLoader = state => state.loader.showSalaryItemLoader